import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-types-papi';
import { Url, USER_PROFILE_POSTS_SUB_PATHS } from '@wix/da-url';
import { MeasuredSlider as Slider } from '@wix/da-shared-react/pkg/Slider';
import SwipeSlider from '@wix/da-shared-react/pkg/SwipeSlider';
import WidgetBox, {
  Props as WidgetBoxProps,
} from '../../../../UserWidgets/_partials/WidgetBox';
import StandardThumb from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard';
import DuperbrowseContext from '../../../../../contexts/DuperbrowseContext';
import EmptyState from '../../_partials/EmptyState';
import PostEditableItem from '../../../../UserWidgets/_partials/PostEditableItem';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { withMobileContext } from '@wix/da-react-context/pkg/MobileContext';

import s from '../PostsAll.scss';

export interface Props {
  streamId: string;
  moduleId: number;
  statuses: PapiDeviation[];
  total: number;
  ownerUsername: string;
  isMobile?: boolean;
}

export class StatusSlider extends React.Component<
  Props & WidgetBoxProps & WithTranslation
> {
  render() {
    const {
      t,
      streamId,
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      moduleId,
      statuses,
      total,
      ownerUsername,
      isMobile,
      section,
      zone,
    } = this.props;
    const isEmpty = !statuses.length;
    return (
      <WidgetBox
        section={section}
        zone={zone}
        header={t!('common.statuses_plural')}
        count={total}
        moduleId={moduleId}
        isEmpty={isEmpty}
        hasMore={!isEmpty} // until we implement inner slider overflow recognition
        emptyView={
          <EmptyState
            className={s['empty-state-status']}
            view="wide"
            postType="status"
            CTAButtonModalType={ModalType.STATUS_UPDATE}
          />
        }
        seeAllUrl={Url.userPostsPath({
          username: ownerUsername,
          subPath: USER_PROFILE_POSTS_SUB_PATHS.STATUSES,
        })}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
      >
        <DuperbrowseContext
          streamId={streamId}
          deviations={statuses}
          parent={{ title: t('duperbrowse.backButton.profile.posts') }}
        >
          {isMobile ? (
            <SwipeSlider>
              {statuses.map(status => (
                <PostEditableItem key={status.deviationId} item={status}>
                  <StandardThumb deviation={status} height={343} />
                </PostEditableItem>
              ))}
            </SwipeSlider>
          ) : (
            <Slider
              renderSliderItems={elementSize =>
                statuses.map(status => (
                  <PostEditableItem key={status.deviationId} item={status}>
                    <StandardThumb
                      deviation={status}
                      width={elementSize.width}
                      height={elementSize.height}
                    />
                  </PostEditableItem>
                ))
              }
            />
          )}
        </DuperbrowseContext>
      </WidgetBox>
    );
  }
}

export default withMobileContext(withTranslation()(StatusSlider));
